'use client';
import { createContext, PropsWithChildren } from 'react';

import { DynamicPageCtx, PageData } from '@/types/ssr';
import { isNotEmpty } from '@/utils/common';
import { getMetaTagValue } from '@/utils/metaTags';
import { getHighestPriorityPlatform } from '@/utils/platform';

type DynamicPagesContextProps = PropsWithChildren<{ pageData?: PageData; authRequired: boolean }>;

export const PagesDataContext = createContext<DynamicPageCtx | null>(null);

export function PageDataProvider({ children, pageData, authRequired }: DynamicPagesContextProps) {
  const metatags = pageData?.metatags;
  const metaPlatform = getMetaTagValue('platform', metatags);
  return (
    <PagesDataContext.Provider
      value={{
        authRequired,
        metaPlatform: getHighestPriorityPlatform(metaPlatform),
        isCrossPlatform: isNotEmpty(metaPlatform.split(',')),
        metaTagsStr: metatags ?? '',
        bodyString: pageData?.body || '',
      }}
    >
      {children}
    </PagesDataContext.Provider>
  );
}
